import { debounce, isString } from 'lodash';
import { updateEventFaq } from '../../app-main/actions/space';
import { TimeMap } from '../../shared-components/search-module/data/time-data';
import { AMENITIES_LIST, EVENT_FAQ_ANSWERS_CONST, EVENT_FAQ_CONST } from '../../shared-components/faq/data/constants';

const {
  OTHER_FOOD_AND_BEVERAGE_RULES,
  OTHER_FOOD_PREP_RULES
} = EVENT_FAQ_ANSWERS_CONST;
const {
  LOUD_MUSIC_ENDS_BY
} = EVENT_FAQ_CONST;

export const generateEventChangePayload = (fieldName, newValue) => {
  if (AMENITIES_LIST.has(fieldName)) {
    // if the toggle is set to Yes / 'true' we can pass an empty object. This will save the state that the user selected an
    // amenity option without entering a quantity or description
    if (newValue && 'true' === newValue) {
      return { [fieldName]: {} };
    }
    if (newValue && 'false' === newValue) {
      // deletes amenity if user selects toggles to 'NO' / false
      return { [fieldName]: { deleted: true } };
    }
  }
  if (OTHER_FOOD_AND_BEVERAGE_RULES === newValue || OTHER_FOOD_PREP_RULES === newValue) {
    // send empty string is user selects the OTHER_FOOD_AND_BEVERAGE_RULES or OTHER_FOOD_PREP_RULES radio button
    // this will save selection state if user does not enter a description in the text area
    return { [fieldName]: '' };
  }
  if ('true' === newValue || 'false' === newValue) {
    // pass in true or false boolean values to API if field requires
    return { [fieldName]: 'true' === newValue };
  }
  return { [fieldName]: newValue };
};

export const onEventFaqChange = (dispatch, spaceId, accessToken, errorHandler) => debounce(async (event, newValue, previousValue, fieldName) => {
  const payload = generateEventChangePayload(fieldName, newValue);
  try {
    await dispatch(updateEventFaq(spaceId, accessToken, payload));
  } catch (e) {
    if (errorHandler) errorHandler();
  }
}, 500);

export const onEventTimeChange = (dispatch, spaceId, accessToken, errorHandler) => async (event, newValue) => {
  // looks up hours and minutes by passing in index value in TimeMap
  const { h, m } = TimeMap[newValue];
  const payload = { [LOUD_MUSIC_ENDS_BY]: { h, m } };
  try {
    await dispatch(updateEventFaq(spaceId, accessToken, payload));
  } catch (e) {
    if (errorHandler) errorHandler();
  }
};

const splitFieldNameAndType = (fieldName) => {
  let key = fieldName;
  let type = null; // This will hold 'description', 'quantity', or null if neither is found

  // Check and split based on '_description'
  if (fieldName.includes('_description')) {
    [key] = fieldName.split('_description');
    type = 'description';
  } else if (fieldName.includes('_quantity')) {
    // Check and split based on '_quantity'
    [key] = fieldName.split('_quantity');
    type = 'quantity';
  } else if (fieldName.includes('_toggle')) {
    [key] = fieldName.split('_toggle');
    type = 'toggle';
  }
  // Return the original key or the split key along with the type of suffix found
  return [key, type];
};

export const onEventMiscItemsChange = (dispatch, spaceId, accessToken, errorHandler) => debounce(async (event, newValue, prevValue, fieldName) => {
  const [formField] = splitFieldNameAndType(fieldName);
  if (!newValue || (isString(newValue) && 'true' !== newValue)) {
    const payload = { [formField]: null };
    try {
      await dispatch(updateEventFaq(spaceId, accessToken, payload));
    } catch (e) {
      if (errorHandler) errorHandler();
    }
  }
}, 500);

export const onEventFaqBlur = (dispatch, spaceId, accessToken, errorHandler) => debounce(async (event, newValue, previousValue, fieldName) => {
  // Remove the //_description or/and _quantity suffix, we only want the original key.
  const [key, type] = splitFieldNameAndType(fieldName);

  // Construct the payload based on the field type.
  const payload = {
    [key]: AMENITIES_LIST.has(key) ? {
      ...('description' === type && { description: newValue }),
      ...('quantity' === type && { quantity: newValue ? parseInt(newValue, 10) : 0 })
    } : newValue
  };

  try {
    await dispatch(updateEventFaq(spaceId, accessToken, payload));
  } catch (e) {
    // Pass the error to the errorHandler.
    if (errorHandler) errorHandler(e);
  }
}, 500);
